import { useEffect, useState } from 'react';
import { formattingNumber } from '../../../Helper/utils/utils';
import { StyledBundlePrice, StyledBundlePriceButton } from './style';
import { BundlePriceProps } from '../../types';

const ProductMadnessBundlePrice = ({
    price,
    isPreview = false
}: BundlePriceProps) => {
    const [finalPrice, setFinalPrice] = useState('');

    useEffect(() => {
        const formattedPrice = formattingNumber(
            price.price,
            price,
            price.isCents,
            price.multiplier,
            !isPreview
        );
        setFinalPrice(formattedPrice);
    }, [price]);

    return (
        <StyledBundlePriceButton className="jackpot-slots-bundle__price-button">
            <StyledBundlePrice
                direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
                marginRight={
                    price.spacing && price.symbolPosition === 'Left'
                        ? '4px'
                        : '0px'
                }
                marginLeft={
                    price.spacing && price.symbolPosition === 'Right'
                        ? '4px'
                        : '0px'
                }
            >
                <div
                    className={'jackpot-slots-bundle__price-button__decoration'}
                ></div>
                <div className="jackpot-slots-bundle__price-button totalPrice">
                    <span>{price.currencySymbol}</span>
                    <span>{finalPrice}</span>
                </div>
            </StyledBundlePrice>
        </StyledBundlePriceButton>
    );
};

export default ProductMadnessBundlePrice;
